<template>
    <div v-if="dataLoaded">
        <manga_detail :manga="manga" :detailUrl="url" :recentChapter="recentChapter"></manga_detail>
    </div>
</template>

<script>
import { HTTP } from "../common/http-common";
import recentMixins from "../common/recent-mixins"

export default {
    name: "Detail",
    mixins: [recentMixins],
    components: {
        manga_detail: () => import("@/components/manga-detail")
    },
    data() {
        return {
            id: 0,
            url: null,
            manga: null,
            dataLoaded: false,
            recentChapter: null
        }
    },
    methods: {
        getDetailData() {
            let path = this.source() + "_new_info/"
            HTTP.get(path, {
                params: {
                    'mangaId': this.id
                }
            })
            .then(response => {
                this.manga = response.data["info"];
                if (this.source() != 'truyenfull') {
                    this.manga.chapters.reverse()
                }
                this.dataLoaded = true

                this.getRecentData('id', this.manga.id)
                    .then(recents => {
                        if (recents.length != 0) {
                            let recent = recents[0]
                            this.getRecentChapter(recent)
                        }
                    })
            })
            .catch(e => {
                console.error(e)
                this.$router.push({ name: 'Home'})
            });
        },
        getRecentChapter(recent) {
            let length = this.manga.chapters.length
            for (var index = 0; index < length; index++) {
                let value = this.manga.chapters[index]
                if (value.url == recent.chapter_id) {
                    value['index'] = index + 1
                    this.recentChapter = value
                    break
                }
            }
        }
    },
    created() {
        this.url = this.$route.params.id
        this.id = this.url.split("-").pop()

        this.getDetailData()
    }
}

</script>

<style lang="scss" scoped>
@import "../styles/components/navigation.scss";
</style>